// SPARK FIELD MAPPINGS
const PRODUCT_PHASE_MAPPING = {
  ACCUMULATION : 'A',
  DISTRIBUTION : 'D', // TODO: currently D = distribution; In fact we want to migrate that toponomy to "Election" instead, so this will become "E"
  PAYOUT       : 'P',
};

const EMPLOYMENT_STATUS_MAPPING = {
  ACTIVE     : 'A',
  TERMINATED : 'T',
  DECEASED   : 'D',
  RETIRED    : 'R',
  SUSPENDED  : 'S',
  REHIRED    : 'H',
  CONVERSION : 'C',
};

const PARTICIPANT_TYPE_MAPPING = {
  EMPLOYEE    : 'E',
  ALTERNATVE  : 'A',
  BENEFICIARY : 'B',
  NON_SPOUSE  : 'N',
};

// TODO - most likely unused
const PARTICIPANT_BENEFICIARY_TYPE_MAPPING = {
  SPOUSE : 'S',
  CHILD  : 'C',
  OTHER  : 'O',
  TRUST  : 'T',
};

const RESIDENCY_CODE_MAPPING = {
  US_CITIZEN      : 'U',
  US_NON_RESIDENT : 'N',
};

const GENDER_MAPPING = {
  MALE        : 'M',
  FEMALE      : 'F',
  OTHER       : 'O',
  UNKNOWN     : 'U',
  TRANSGENDER : 'T',
  NON_BINARY  : 'N',
};

const MARITAL_STATUS_MAPPING = {
  SINGLE   : 'S',
  MARRIED  : 'M',
  WIDOWED    : 'W',
  DIVORCED : 'D',
};

// based on SPARK
const FREQUENCY_MAPPING = {
  BI_WEEKLY     : 'B',
  WEEKLY        : 'W',
  MONTHLY       : 'M',
  DAILY         : 'D',
  SEMI_ANNUALLY : 'S',
  SEMI_MONTHLY  : 'T',
  QUARTERLY     : 'Q',
  ANNUALLY      : 'A',
  OTHER         : 'O',
};

const TAX_INDICATOR_MAPPING = {
  ROTH       : 'R',
  BEFORE_TAX : 'N',
  AFTER_TAX  : 'Y',
};

const PLAN_PAYOUT_MAPPING = {
  IN_PLAN     : 'I',
  OUT_OF_PLAN : 'O',
};

const PLAN_ALGORITHM_MAPPING = {
  ALLOCATION  : 'allocation',
  PICK_ONE    : 'pickone',
  DAISY_CHAIN : 'daisychain',
  BEST_PRICE  : 'bestprice',
};

const PLAN_PRODUCT_TYPE_MAPPING = {
  DEFERRED_INCOME_ANNUITY              : 'DIA',
  DEFERRED_ANNUITY                     : 'DA',
  GUARANTEED_MINIMUM_WITHDRAWL_BENEFIT : 'GMWB',
  SINGLE_PREMIUM_IMMEDIATE_ANNUITY     : 'SPIA',
  QUALIFIED_LONGEVITY_ANNUITY_CONTRACT : 'QLAC',
};

// All plans use codes for product_type, not full naming used in PLAN_PRODUCT_TYPE_MAPPING
const PLAN_PRODUCT_TYPE_CODE_MAPPING = {
  SPIA: 'SPIA',
  QLAC: 'QLAC',
  DRAWDOWN: 'DRAWDOWN',
  GMWB: 'GMWB',
  SS: 'SS',
};

const BUSINESS_PROCESS_TYPES = {
  QLAC_ANNUITY:     'QLAC_ANNUITY',
  SPIA_ANNUITY_ROTH: 'SPIA_ANNUITY_ROTH',
  SPIA_ANNUITY_TRAD: 'SPIA_ANNUITY_TRAD',
};

const FUND_SOURCE_TYPE_MAPPING = {
  MIXED: 'mixed',
  ROTH: 'roth',
  NONROTH: 'non-roth',
};

const PLAN_TYPE_MAPPING = {
  '401K'                 : '401K',
  '401A'                 : '401A',
  '403B'                 : '403B',
  '457B'                 : '457B',
  '457F'                 : '457F',
  'MICRUITY_PLACEHOLDER' : 'MIC',
  'OTHER'                : 'OTHER',
};

const PLAN_OFFER_AS_MAPPING = { // consider renaming
  TARGET_DATE_FUND : 'TDF',
  DIRECT_BUY       : 'DIR',
  MODEL_PORTFOLIO  : 'MOD',
};

const PAYOUT_METHOD_MAPPING = {
  CHECK          : 'C',
  DIRECT_DEPOSIT : 'D',
};

const PARTICIPANT_IDENTIFIER_TYPE_MAPPING = {
  SSN   : 'S',
  OTHER : 'O',
};

const COUNTRY_CODE_MAPPING = {
  US     : 'US',
  CANADA : 'CA',
};

const BENEFIT_TYPE_MAPPING = {
  SINGLE         : 'S',
  JOINT          : 'J',
  PERIOD_CERTAIN : 'C',
};

// https://docs.google.com/spreadsheets/d/1U5Xebt3Zjogtb1HjYNsvf-OB7KiGd8Jk/edit#gid=1642477438
const TRANSACTION_TYPE_MAPPING = {
  //                                       PRICING EFFECT       FUNDING EFFECT
  CONTRIBUTION                  : '01', // Guarantee Added      Amount In
  EXCHANGE_BUY                  : '02', // Guarantee Added      Amount In
  EXCHANGE_SELL                 : '03', // Guarantee Subtracted Amount Out
  FREE_EXCHANGE                 : '04', // Guarantee Added      Amount In // TODO - should be subtract
  FEE                           : '05', // No effect            No effect // TODO - should be subtract
  RETURN_OF_EXCESS              : '06', // Guarantee Added      Amount In // TODO - should be subtract
  DISBURSEMENTS                 : '07', // Guarantee Subtracted Amount Out
  COMPANY_ADMIN_TRANSFER        : '08', // Guarantee Subtracted Amount Out
  LOAN_REPAYMENT                : '09', // Guarantee Added      Amount In
  PLAN_TRANSFER_IN              : '10', // Guarantee Added      Amount In
  PLAN_TRANSFER_OUT             : '11', // Guarantee Subtracted Amount Out
  ROLLOVER_IN                   : '12', // Guarantee Added      Amount In
  ROLLOVER_OUT                  : '13', // Guarantee Subtracted Amount Out
  ADJUSTMENTS                   : '14', // Guarantee Added      Amount In - Mike suggested that this is always positive
  FINAL_DISBURSEMENT            : '15', // Guarantee Subtracted Amount Out
  MRD                           : '16', // Guarantee Subtracted Amount Out
  ANNUITIZATION                 : '17', // No effect            No effect
  QDRO_BENEFICIARY_TRANSFER_IN  : '18', // Guarantee Added      Amount In
  QDRO_BENEFICIARY_TRANSFER_OUT : '19', // Guarantee Subtracted Amount Out
  INDICATIVE_DATA_ONLY          : '99', // No effect            No effect
};

const TRANSACTION_TYPE_SUBTRACTIONS = [
  TRANSACTION_TYPE_MAPPING.EXCHANGE_SELL,
  TRANSACTION_TYPE_MAPPING.DISBURSEMENTS,
  TRANSACTION_TYPE_MAPPING.COMPANY_ADMIN_TRANSFER,
  TRANSACTION_TYPE_MAPPING.PLAN_TRANSFER_OUT,
  TRANSACTION_TYPE_MAPPING.ROLLOVER_OUT,
  TRANSACTION_TYPE_MAPPING.FINAL_DISBURSEMENT,
  TRANSACTION_TYPE_MAPPING.MRD,
  TRANSACTION_TYPE_MAPPING.QDRO_BENEFICIARY_TRANSFER_OUT,
];

// TODO: DEPRECATED, use one in Election(ret. profile) model
const ELECTION_STATUS_MAPPING = {
  PARTICIPANT_IN_PROGRESS         : 'participant-in-progress',
  READY_TO_SIGN                   : 'ready-to-sign',
  READY_TO_NOTARIZE               : 'ready-to-notarize',
  READY_TO_SUBMIT                 : 'ready-to-submit',
  SUBMITTED_FOR_INSURER_IGO       : 'submitted-for-insurer-igo',
  SUBMITTED_FOR_RECORD_KEEPER_IGO : 'submitted-for-recordkeeper-igo',
  REJECTED                        : 'rejected',
  APPROVED_BY_INSURER             : 'approved-by-insurer',
  APPROVED_BY_RECORD_KEEPER       : 'approved-by-recordkeeper',
  SOURCE_WIRE_RECEIVED            : 'source-wire-received',
  SOURCE_WIRE_NOT_RECEIVED        : 'source-wire-not-received',
  COMPLETED                       : 'completed',
  ACTIVE                          : 'active',
  COMPLETED_NO_SOURCE_WIRE        : 'completed-no-source-wire',
  CANCELLED                       : 'cancelled',
  EXPIRED                         : 'expired',
  PAUSED                          : 'paused',
};

const FUND_STATUS_MAPPING = {
  SENT      : 'sent',
  NOT_SENT  : 'not-sent',
  REFUNDED  : 'refunded',
};

const ELECTION_STATUS_REASON_MAPPING = {
  // 1xxx - pre wire errors
  PERMANENT_RESIDENT_STATUS_FAILED                : '1001',
  DECLARED_PREMIUM_EXCEEDS_MAX_AGGREGATE_LIMIT    : '1002',
  // 2xxx - post wire errors
  RECEIVED_PREMIUM_IS_LESS_THAN_REQUIRED_MINIMUM  : '2001',
  RECEIVED_PREMIUM_EXCEEDS_MAX_AGGREGATE_LIMIT    : '2002',
  INSURER_DID_NOT_RECIEVE_FUND                    : '2003',
  // 4xxx - rejected or cancelled
  FREE_LOOK_CANCELLATION                          : '4001',
  PARTICIPANT_INSUFFICIENT_FUNDS                  : '4002',
  PARTICIPANT_DECEASED                            : '4444',
  REASON_NOT_LISTED                               : '9999',
};

const ELECTION_TAX_WITHHOLDING_STATUS_MAPPING = {
  SINGLE: 'single',
  MARRIED: 'married',
  MARRIED_JOINT: 'married-joint',
  MARRIED_JOINT_ONE: 'married-joint-one',
  MARRIED_JOINT_BOTH: 'married-joint-both',
  MARRIED_SEPARATE: 'married-separate',
  HOUSEHOLD: 'household',
  HEAD_OF_HOUSEHOLD: 'head_of_household',
};

const API_DETERMINATORS_MAPPING = {
  AMERICAN_EQUITY     : 'ael',
  CANNEX              : 'cannex',
  CANNEX_BATCH        : 'cannex_batch',
  COHERENT            : 'coherent',
  METLIFE             : 'metlife',
  MOCK_API            : 'mock_api',
  PRUDENTIAL          : 'prudential',
  SSGA_DRAWDOWN       : 'ssga_drawdown',
  JPM_DRAWDOWN        : 'jpm_drawdown',
  JPM_SOCIAL_SECURITY : 'jpm_social_security',
};

const CERTIFICATE_STATUS_MAPPING = {
  ACTIVE    : 'active',
  REJECTED  : 'rejected',
  CANCELLED : 'cancelled',
  EXPIRED   : 'expired',
};

const INCOME_SOLUTIONS_MAPPING = {
  METLIFE : 'metlife-iia',
  SSGA    : 'ssga-incomewise',
  GID     : 'fidelity-gid',
  ALIGHT  : 'alight-ric',
};

const BENEFICIARY_RELATIONSHIP_MAPPING = {
  SPOUSE: 'spouse',
  NON_SPOUSE: 'non-spouse',
  DOMESTIC_PARTNER: 'domestic-partner',
  MOTHER: 'mother',
  FATHER: 'father',
  BROTHER: 'brother',
  SISTER: 'sister',
  SON: 'son',
  DAUGHTER: 'daughter',
  OTHER: 'other',
  ESTATE: 'estate',
  TRUST: 'trust',
  BUSINESS_PARTNER: 'business-partner',
  FRIEND: 'friend',
  GRANDCHILD: 'grandchild',
  NIECE: 'niece',
  NEPHEW: 'nephew',
  STEP_PARENT: 'step-parent',
  STEP_CHILD: 'step-child',
  STEP_SIBLING: 'step-sibling',
  CHARITY: 'charity',
  EMPLOYER: 'employer',
};

const BENEFICIARY_TYPE_MAPPING = {
  PRIMARY: 'P',
  CONTINGENT: 'C',
};

const CERTIFICATE_STATUS_REASON_MAPPING = {
  // 3xxx - errors
  RECEIVED_PREMIUM_IS_LESS_THAN_REQUIRED_MINIMUM  : '3001',
  RECEIVED_PREMIUM_EXCEEDS_MAX_AGGREGATE_LIMIT    : '3002',
  INSURER_DID_NOT_RECIEVE_FUND                    : '3003',
  PERMANENT_RESIDENT_STATUS_FAILED                : '3004',
  // 4xxx - rejected or cancelled
  FREE_LOOK_CANCELLATION                          : '4001',
  REASON_NOT_LISTED                               : '9999',
};

const SUPPORTED_AWS_REGIONS = {
  US_EAST_1: 'us-east-1',
  US_WEST_1: 'us-west-1',
  US_EAST_2: 'us-east-2',
  US_WEST_2: 'us-west-2',
};

const SOCIAL_SECURITY_BENEFIT_SOURCES = {
  FACTOR_TABLE: 'factor_table',
  ANNUITANT_INPUT_YEARLY_BENEFIT: 'annuitant_input_yearly_benefit',
};

module.exports = {
  PARTICIPANT_TYPE_MAPPING,
  PRODUCT_PHASE_MAPPING,
  MARITAL_STATUS_MAPPING,
  PAYOUT_METHOD_MAPPING,
  RESIDENCY_CODE_MAPPING,
  PARTICIPANT_IDENTIFIER_TYPE_MAPPING,
  EMPLOYMENT_STATUS_MAPPING,
  COUNTRY_CODE_MAPPING,
  PARTICIPANT_BENEFICIARY_TYPE_MAPPING,
  GENDER_MAPPING,
  FREQUENCY_MAPPING,
  BENEFIT_TYPE_MAPPING,
  PLAN_TYPE_MAPPING,
  PLAN_PAYOUT_MAPPING,
  PLAN_OFFER_AS_MAPPING,
  TRANSACTION_TYPE_MAPPING,
  TAX_INDICATOR_MAPPING,
  TRANSACTION_TYPE_SUBTRACTIONS,
  PLAN_PRODUCT_TYPE_MAPPING,
  PLAN_PRODUCT_TYPE_CODE_MAPPING,
  PLAN_ALGORITHM_MAPPING,
  ELECTION_STATUS_MAPPING,
  FUND_STATUS_MAPPING,
  ELECTION_STATUS_REASON_MAPPING,
  ELECTION_TAX_WITHHOLDING_STATUS_MAPPING,
  API_DETERMINATORS_MAPPING,
  CERTIFICATE_STATUS_MAPPING,
  CERTIFICATE_STATUS_REASON_MAPPING,
  BENEFICIARY_RELATIONSHIP_MAPPING,
  BENEFICIARY_TYPE_MAPPING,
  SUPPORTED_AWS_REGIONS,
  FUND_SOURCE_TYPE_MAPPING,
  INCOME_SOLUTIONS_MAPPING,
  SOCIAL_SECURITY_BENEFIT_SOURCES,
  BUSINESS_PROCESS_TYPES,
};

// Copyright © 2023 Micruity Inc.
